// extracted by mini-css-extract-plugin
export default {"cls1":"BackButton-cls1__d1d8974ced0fe499fb12","cls2":"BackButton-cls2___f7e46643dae5bbdd759 BackButton-cls1__d1d8974ced0fe499fb12"};